import { createGlobalStyle } from 'styled-components';

import BraceWebRegularWoffTwo from '../assets/fonts/brace-web-regular.woff2';
import BraceWebRegularWoff from '../assets/fonts/brace-web-regular.woff';
import BraceWebRegularEOT from '../assets/fonts/brace-web-regular.eot';
import BraceWebRegularTTF from '../assets/fonts/brace-web-regular.ttf';

import BraceWebLightWoffTwo from '../assets/fonts/brace-web-light.woff2';
import BraceWebLightWoff from '../assets/fonts/brace-web-light.woff';
import BraceWebLightEOT from '../assets/fonts/brace-web-light.eot';
import BraceWebLightTTF from '../assets/fonts/brace-web-light.ttf';

export default createGlobalStyle`
  @font-face {
    font-family: 'BraceWeb-Regular';
    src:
      url('${BraceWebRegularEOT}'),
      url('${BraceWebRegularEOT}?#iefix') format('embedded-opentype'),
      url('${BraceWebRegularWoffTwo}') format('woff2'),
      url('${BraceWebRegularWoff}') format('woff');
      url('${BraceWebRegularTTF}') format('truetype');
  }
  @font-face {
    font-family: 'BraceWeb-Light';
    src:
      url('${BraceWebLightEOT}'),
      url('${BraceWebLightEOT}?#iefix') format('embedded-opentype'),
      url('${BraceWebLightWoffTwo}') format('woff2'),
      url('${BraceWebLightWoff}') format('woff');
      url('${BraceWebLightTTF}') format('truetype');
  }
`;
